import React from "react";
import { useHistory } from "react-router-dom";
import styles from "./VideoList.module.scss";
import BaseTable, { AutoResizer, Column } from "react-base-table";
import customTableComponents from "./VideoListTableComponent";
import _ from "lodash";
import { Spinner } from "@blueprintjs/core";
import CreateProductPrompt from "./CreateProductPrompt";
import FirstVideoPrompt from "./FirstVideoPrompt";

function VideoList({
  isLoading,
  videos,
  columns,
  columnWidths,
  getColumnWidth,
  onColumnResize,
  onVideoClick,
  searchText,
  filters,
  products,
  selectedTab,
  onAddVideo
}) {
  const history = useHistory();

  if (
    !isLoading &&
    videos &&
    !videos.length &&
    !searchText &&
    _.isEmpty(filters)
  ) {
    if (!products || !products.length) {
      return (
        <div className={styles.promptWrapper}>
          <CreateProductPrompt
            onVisitProductsClick={() => history.push("/products")}
          />
        </div>
      );
    }
    if(selectedTab !== "archives")
    return (
      <div className={styles.promptWrapper}>
        <FirstVideoPrompt
          onAddVideoClick={onAddVideo}
          selectedTab={selectedTab}
        />
      </div>
    );
  }

  return (
    <div className={styles.tableWrapper}>
      <AutoResizer>
        {({ width, height }) => {
          return (
            <BaseTable
              fixed
              data={videos || []}
              width={width}
              height={height}
              components={customTableComponents()}
              emptyRenderer={
                isLoading ? (
                  <div className={styles.empty}>
                    <Spinner />
                  </div>
                ) : (
                  <div className={styles.empty}>No Videos Found</div>
                )
              }
              onColumnResizeEnd={onColumnResize}
              className={styles.mainTable}
              rowEventHandlers={{
                onClick: ({ rowData }) => {
                  if(selectedTab !== 'archives')
                    onVideoClick(rowData)
              }}}
            >
              {columns.map((column, index) => (
                <Column
                  {...column}
                  width={getColumnWidth({ columnWidths, index, width })}
                />
              ))}
            </BaseTable>
          );
        }}
      </AutoResizer>
    </div>
  );
}

export default VideoList;
